import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'api';

export const APP_API_REDUCER_KEY = 'appApi';

export const appApi = createApi({
  reducerPath: APP_API_REDUCER_KEY,
  baseQuery: axiosBaseQuery({ token_required: true }),
  tagTypes: ['Promotions'],
  endpoints: () => ({}),
});
